import { gql, useQuery } from '@apollo/client';
import { isDefinedAndNotNull } from '@pendwa/common/utils/isDefinedAndNotNull.js';
import { defaultErrorsHandler } from '../../core/apollo/utils.js';
const GRAPHQL_QUERY = gql `
  fragment fragmentPageDataCountry on TypeCountry {
    code
    dial_code
    name
    is_united_states
    is_tanzania
  }

  query hooksPageDataCountry {
    country {
      ...fragmentPageDataCountry
    }
  }
`;
export const usePageDataCountry = () => {
    const result = useQuery(GRAPHQL_QUERY, {
        // must be refreshed from the network every time
        fetchPolicy: 'network-only',
    });
    defaultErrorsHandler(result.error);
    return {
        error: result.error,
        refetch: result.refetch,
        loading: result.loading && !result.data,
        data: isDefinedAndNotNull(result.data?.country) ? result.data.country : undefined,
    };
};
//# sourceMappingURL=usePageDataCountry.js.map